import { useEffect, useRef } from "react";

import { useDisclosure } from "@mantine/hooks";
import { Burger } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { IconBrandWhatsapp, IconPhone } from "@tabler/icons-react";

const Header = () => {
  const navigate = useNavigate();

  const [opened, { toggle }] = useDisclosure(false);

  const phoneMenuListRef = useRef<HTMLDivElement>(null);
  const burgerIconRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    burgerIconRef.current?.addEventListener("click", () => {
      opened
        ? (phoneMenuListRef.current!.style.transform = "translate(0, -120%)")
        : (phoneMenuListRef.current!.style.transform = "translate(0, 0)");
    });
  }, [opened]);

  const menuOnclick = (link: string) => {
    let menuHeight =
      document.querySelector<HTMLDivElement>("#header")!.offsetHeight;

    var location = document.querySelector<HTMLDivElement>(link)!.offsetTop;

    window.scrollY &&
      window.scrollTo({
        top: location - menuHeight,
        behavior: "smooth",
      });
  };

  const phoneMenuOnclick = (link: string) => {
    let menuHeight =
      document.querySelector<HTMLDivElement>("#header")!.offsetHeight;

    var location = document.querySelector<HTMLDivElement>(link)!.offsetTop;

    window.scrollY &&
      window.scrollTo({
        top: location - menuHeight,
        behavior: "smooth",
      });

    toggle();
    phoneMenuListRef.current!.style.transform = "translate(0, -100%)";
  };
  return (
    <header className="fixed left-0 top-0 w-full h-fit max-w-[100vw] bg-white z-40">
      <div
        id="header"
        className="relative w-full h-fit px-[calc((100%-var(--container))/2)] py-2 max-h-20 xl:max-h-32 overflow-hidden z-40 transition-all duration-300"
      >
        <div className="relative w-full h-full mx-auto flex justify-between items-center gap-6 xl:gap-16">
          <Burger
            ref={burgerIconRef}
            opened={opened}
            onClick={toggle}
            className="block xl:hidden"
            size="md"
          />
          <div className="relative w-full h-fit max-w-52 xl:max-w-64">
            <img
              alt="logo"
              onClick={() => navigate("/")}
              className="!relative w-full h-auto max-h-16 xl:max-h-20 py-3 object-contain cursor-pointer"
              src="/images/logo.png"
              width={429}
              height={153}
            />
          </div>
          <div className="block xl:hidden relative w-fit h-fit p-1 mx-1 rounded-full">
            <IconPhone
              onClick={() => {
                window.location.href = "tel:02-6953-7311";
              }}
              size={30}
              stroke={1.3}
              className=" rotate-[270deg]"
            />
          </div>
          <ul className="hidden relative w-fit h-fit text-center xl:flex justify-around items-center justify-items-center gap-4 xl:gap-6 3xl:gap-8 cursor-pointer">
            <li className="hoverLine" onClick={() => menuOnclick("#master")}>
              <p>COFFEE&nbsp;MASTER</p>
            </li>
            <li className="hoverLine" onClick={() => menuOnclick("#product")}>
              <p>PRODUCT&nbsp;LINE</p>
            </li>
            <li className="hoverLine" onClick={() => menuOnclick("#art")}>
              <p>COFFEE&nbsp;IS&nbsp;ART</p>
            </li>
            <li className="hoverLine" onClick={() => menuOnclick("#explorer")}>
              <p>GB&nbsp;EXPLORER</p>
            </li>
            <li className="hoverLine" onClick={() => menuOnclick("#special")}>
              <p>SPECIAL&nbsp;GREEB&nbsp;BEAN</p>
            </li>
            <li className="hoverLine" onClick={() => menuOnclick("#contact")}>
              <p>CONTACT&nbsp;US</p>
            </li>
          </ul>
        </div>
      </div>
      <div
        ref={phoneMenuListRef}
        className="block lg:hidden fixed top-20 left-0 w-full h-full -translate-y-full transition-transform duration-500 z-30"
      >
        <ul className="border-b bg-white text-font">
          <li
            className=" hover:font-black "
            onClick={() => phoneMenuOnclick("#master")}
          >
            <p className="border-b py-4 text-center text-sm ">
              COFFEE&nbsp;MASTER
            </p>
          </li>
          <li
            className=" hover:font-black"
            onClick={() => phoneMenuOnclick("#art")}
          >
            <p className="border-b py-4 text-center text-sm">
              COFFEE&nbsp;IS&nbsp;ART
            </p>
          </li>
          <li
            className=" hover:font-black"
            onClick={() => phoneMenuOnclick("#explorer")}
          >
            <p className="border-b py-4 text-center text-sm">
              GB&nbsp;EXPLORER
            </p>
          </li>
          <li
            className=" hover:font-black"
            onClick={() => phoneMenuOnclick("#special")}
          >
            <p className="border-b py-4 text-center text-sm">
              SPECIAL&nbsp;GREEB&nbsp;BEAN
            </p>
          </li>
          <li
            className=" hover:font-black"
            onClick={() => phoneMenuOnclick("#product")}
          >
            <p className="border-b py-4 text-center text-sm">
              PRODUCT&nbsp;LINE
            </p>
          </li>
          <li
            className=" hover:font-black"
            onClick={() => phoneMenuOnclick("#contact")}
          >
            <p className="border-b py-4 text-center text-sm">CONTACT&nbsp;US</p>
          </li>
        </ul>
      </div>
    </header>
  );
};

export default Header;
